
import VueRouter from 'vue-router'
import routes from './routes'
import store from '@/store'
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve && onReject) return originalPush.call(this, location, onResolve, onReject);
	return originalPush.call(this, location).catch(err => err);
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location,onResolve, onReject) {
	if (onResolve && onReject) return originalReplace.call(this, location, onResolve, onReject);
	return originalReplace.call(this, location).catch(err => err);
}

const router = new VueRouter({
	mode: 'history',
	routes
})

router.beforeEach(async (to, from, next) => {

	window.scrollTo(0, 0)
	// 代报中心路由的路径前缀
	const proxyCenterPrefix = '/BigData/ProxyCenter';
	// 检查to.path是否以代报中心的路径前缀开头
	if (to.path.startsWith(proxyCenterPrefix)) {
		// 获取带命名空间的 state 中的 wxData.accStatus
		const req = await store.dispatch('home/getUserInofo');
		// console.log(req)
		// 根据 accStatus 判断是否允许访问
		if (req.wxData && req.wxData.accStatus == 1) {
			next(); // 允许访问，继续路由跳转
		} else {
			next({ name: 'PatentSearch' }); // 不允许访问，重定向到指定页面
			next()
		}
	} else {
		// 不是代报中心相关路由，正常跳转
		next();
	}
})


router.afterEach((to, from) => {
	document.title = to.meta.title || '胜博知识产权'
})

export default router